import React, { useContext } from "react";
import { HeaderContext } from "../../../../../../../store/context/header-context";
import { getTrueClasses } from "../../../../../../../helpers";

const TitleCategory = ({ title, icon }) => {
  const { t } = useContext(HeaderContext);
  return (
    <div className="GCL-H-T-T-C-TC">
      <p className="GCL-H-T-T-C-TC__title">{t(title)}</p>
      {icon && (
        <span
          className={getTrueClasses(
            "GCL-H-T-T-C-TC__icon",
            `GCL-H-T-T-C-TC__icon_${icon}`
          )}
        >
          {t(icon)}
        </span>
      )}
    </div>
  );
};
export default TitleCategory;
